#import "../fragments/lead-fragment.graphql"

mutation LeadSetWatched($lead: LeadSetWatchedInputFieldInput!) {
    leadSetWatched(input: {lead: $lead}) {
        lead {
            ...Lead
        }
    }
}
